export const formatMoney = (value: number) => {
  const temp = Number(value);
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'CAD',
  });
  return formatter.format(temp);
};
